import {ExpertAnketaReview} from './ExpertAnketaReview';

export default ExpertAnketaReview;